import FormColorControl from './FormColorControl';
import React, { ChangeEvent, memo } from 'react';
import { formActions, rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { IColor } from '../../interfaces';
import { updateArtTextBackground } from '../../domain/art-text-provider';

const FormBackgroundColor = () => {

    const dispatch = useAppDispatch();

    const artTextSVG = useAppSelector(store => store.root.artTextSVG);
    const backgroundColor = useAppSelector(store => store.form.backgroundColor);
    const backgroundColorEnabled = useAppSelector(store => store.form.backgroundColorEnabled);

    const updateColor = (updatedColor: IColor) => {

        dispatch(
            formActions.main({
                backgroundColor: updatedColor,
            })
        );

        const updatedSVG = updateArtTextBackground(artTextSVG, updatedColor, backgroundColorEnabled);

        dispatch(
            rootActions.main({
                artTextSVG: updatedSVG,
            })
        );
    };

    const enableDisableBackgroundColor = (evt: ChangeEvent<HTMLInputElement>) => {

        dispatch(
            formActions.main({
                backgroundColorEnabled: evt.target.checked,
            })
        );

        const updatedSVG = updateArtTextBackground(artTextSVG, backgroundColor, evt.target.checked);

        dispatch(
            rootActions.main({
                artTextSVG: updatedSVG,
            })
        );
    };

    return (
       <div className="mr-10 mb-4">
           <label className="mb-2 inline-block">Background Color</label>
           <div className="flex items-center mt-2">

               <input
                   type="checkbox"
                   className="mr-4"
                   checked={ backgroundColorEnabled }
                   onChange={ enableDisableBackgroundColor }
               />

               <FormColorControl
                   rgbaColor={ backgroundColor }
                   onChange={ (updatedColor) => {
                       updateColor(updatedColor);
                   }}
               />
           </div>
       </div>
    )
}

export default memo(FormBackgroundColor);